var exports = {
  "k": "x4c3adb35--914ee7--container",
};

module.exports = exports;
